module.exports = __webpack_public_path__ + "static/img/animales_20.91bf1394.jpg";